module.exports = __webpack_public_path__ + "bf8b9ec47b03f46f57b202c6a384729b.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.ttf?t=1557132315021
// module id = 14
// module chunks = 0